export default{
    inventories: [],
    error: false,
    errorMessage: '',
    params: {
        paginate: true,
        page: 1,
        perPage: 30,
        filter: '',
        sortBy: 'id',
        sort: 'ASC'
    },
    inventoryAge: []

}



// WEBPACK FOOTER //
// ./src/modules/inventories/state.js